import { put, select, call } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import services from '@services'
import { ApplicationState } from '@store/types'
import { setIdIteracao, setTipoDocumento } from '@store/refinanciamento/proposta/actions'
import { BridgeService } from '@services/bridge'
import { HttpStatus } from '@services/base'
import { logout } from '@utils/functions'
import { ErroType } from '@utils/types'
import { CapturaDocumentoRequest } from '@services/getCaptureDocumentsService'
import { DocumentosEnvioType } from '@store/refinanciamento/proposta/types'

import { hideLoading, captureDocumentos, showLoading } from '../actions'

interface Props {
  noRemoveLoader: boolean
  actionCallbackError: {
    message: string
    actionCallback: () => AnyAction
    actionTitle: string
  }
  type: string
}

export default function* captureDocumentsSaga({
  noRemoveLoader,
  actionCallbackError = {
    message: 'Aguarde um instante e tente novamente.',
    actionCallback: () => captureDocumentos(),
    actionTitle: 'Tentar Novamente',
  },
}: Props) {
  try {
    const appState = yield* select((state: ApplicationState) => state)
    const propostaInfo = yield* select((state: ApplicationState) => state.refinanciamento.proposta)
    const propostaAntiga = appState.refinanciamento.contratos.contratosSelecionados.map(
      (item) => item.numeroProposta,
    )[0]
    let data: CapturaDocumentoRequest
    let status: number
    // Caso ja tenha carregado os documentos, não busca novamente para evitar erro de criação de integração com GEDIN
    if (!propostaInfo?.tipoDocumento) {
      yield put(showLoading())

      if (BridgeService.isBrowser()) {
        const response = yield* call(
          services.getCaptureDocumentsService,
          appState.session.accessToken,
        )
        data = response?.data
        status = response?.status
      } else {
        const response = yield* call(
          services.postCaptureDocumentsService,
          {
            cpf: appState.refinanciamento.dadosPessoais.cpfDadosPessoais ?? '',
            numeroProposta: String(
              appState.refinanciamento.proposta.numeroProposta ?? propostaAntiga,
            ),
          },
          appState.session.accessToken,
        )
        data = response?.data
        status = response?.status
      }

      if (data) {
        const tipoDocumento = data.enviados.concat(data.pendentes) as DocumentosEnvioType[]
        yield put(setTipoDocumento(tipoDocumento))
        yield put(setIdIteracao(data.idInteracao))
      }

      if (!noRemoveLoader) {
        yield put(hideLoading())
      }

      if (data && status === 200) {
        yield put(
          setLastServiceResponse({
            code: 'OK',
            serviceName: BridgeService.isBrowser()
              ? 'getCaptureDocumentsService'
              : 'postCaptureDocumentsService',
          }),
        )
        return true
      }
    }

    if (propostaInfo?.tipoDocumento) return true

    yield put(showError(actionCallbackError))

    return false
  } catch (error) {
    yield put(
      setLastServiceResponse({
        code: 'ERROR',
        serviceName: BridgeService.isBrowser()
          ? 'getCaptureDocumentsService'
          : 'postCaptureDocumentsService',
      }),
    )
    const erroTyped = error as ErroType
    yield put(hideLoading())
    if (BridgeService.isBrowser() && erroTyped.status === HttpStatus.UNAUTHORIZED) {
      yield put(
        showError({
          title: 'Sessão expirada',
          message: 'Efetue o login novamente.',
          actionTitle: 'Continuar',
          functionCallback: () => logout(),
        }),
      )
      return false
    }
    yield put(showError(actionCallbackError))
    return false
  }
}
